export function resolveBrowserRouterBasename(
  pathname: string | null | undefined,
): string {
  const normalizedPathname = String(pathname || "").trim() || "/";
  const match = normalizedPathname.match(/^\/workhorse\/apps\/[^/]+/);
  return match?.[0] || "/";
}
